module.exports = __webpack_public_path__ + "img/烹饪.c35e3db0.webp";